<div class="container">
  <div class="authentication-card">
    <!-- Loading -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Validando link...</p>
    </div>

    <div *ngIf="!isLoading && isValid" class="content">
      <!-- Header do contador -->
      <div class="header-section">
        <h2>{{ clientName }}</h2>
        <div class="paragraf-section">
          <p>{{ clientEmail }}</p>
          <p class="document">{{ clientDocument }}</p>
        </div>
      </div>

      <!-- Dados do cliente -->
      <div class="section">
        <h3>Dados da Empresa</h3>
        <form [formGroup]="companyForm" class="company-form">
          <app-cep [controlName]="'address'" class="full-width"></app-cep>

          <app-company-document [controlName]="'cnpj'" [label]="'CNPJ'"></app-company-document>

          <app-inscricao-estadual [controlName]="'stateRegistration'"></app-inscricao-estadual>

          <mat-form-field appearance="outline" class="medium-input-grid">
            <mat-label>Razão Social</mat-label>
            <input type="text" matInput formControlName="companyName">
          </mat-form-field>

          <mat-form-field appearance="outline" class="medium-input-grid default-left-margin-input-field">
            <mat-label>Nome Fantasia</mat-label>
            <input type="text" matInput formControlName="fantasyName">
          </mat-form-field>

          <mat-form-field appearance="outline" class="medium-input-grid">
            <mat-label>Telefone</mat-label>
            <ngx-mat-intl-tel-input
              [preferredCountries]="['br']"
              formControlName="phone"
              [enablePlaceholder]="true"
              [required]="true"
              [enableSearch]="true"
              (countryChanged)="dialCodeChange($event.dialCode)">
            </ngx-mat-intl-tel-input>
          </mat-form-field>

          <div class="section-actions">
            <button mat-raised-button color="primary" (click)="onSaveCompanyData()" [disabled]="isSavingCompany" type="button">
              <mat-icon *ngIf="!isSavingCompany">save</mat-icon>
              <mat-spinner diameter="20" *ngIf="isSavingCompany" style="display: inline-block; margin-right: 8px;"></mat-spinner>
              {{ isSavingCompany ? 'Salvando...' : 'Salvar Dados da Empresa' }}
            </button>
          </div>
        </form>
      </div>

      <!-- Número de série -->
      <ng-container>
        <div class="section">
          <h3>Número de Série do PDV</h3>

          <table class="pdv-table" *ngIf="pdvList.length > 0">
            <thead>
              <tr>
                <th>PDV</th>
                <th>Série</th>
                <th>Numeração</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let pdv of pdvPagedList">
                <!-- Linha visualização -->
                <tr *ngIf="editingPdvId !== pdv.id">
                  <td>{{ pdv.description }}</td>
                  <td>{{ pdv.serie }}</td>
                  <td>{{ pdv.numeration + 1 }}</td>
                  <td class="pdv-action-cell">
                    <button mat-icon-button (click)="editingPdvId = pdv.id; editingPdvNumeration = pdv.numeration + 1" type="button" title="Editar">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </td>
                </tr>
                <!-- Linha edição -->
                <tr *ngIf="editingPdvId === pdv.id" class="pdv-editing-row">
                  <td>{{ pdv.description }}</td>
                  <td>
                    <mat-form-field appearance="outline" class="pdv-field">
                      <input matInput type="number" [(ngModel)]="pdv.serie">
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline" class="pdv-field">
                      <input matInput type="number" [(ngModel)]="editingPdvNumeration">
                    </mat-form-field>
                  </td>
                  <td class="pdv-action-cell">
                    <button mat-icon-button color="primary" (click)="onSavePdvInformation(pdv)"
                      [disabled]="isSavingPdv" type="button" title="Salvar">
                      <mat-icon *ngIf="!isSavingPdv">save</mat-icon>
                      <mat-spinner diameter="20" *ngIf="isSavingPdv"></mat-spinner>
                    </button>
                    <button mat-icon-button (click)="editingPdvId = null" type="button" title="Cancelar">
                      <mat-icon>close</mat-icon>
                    </button>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>

          <mat-paginator *ngIf="pdvList.length > pdvPageSize"
            [length]="pdvList.length"
            [pageSize]="pdvPageSize"
            [pageSizeOptions]="[10, 25, 50]"
            (page)="onPdvPageChange($event)">
          </mat-paginator>

          <div *ngIf="pdvList.length === 0" class="new-pdv-form">
            <p class="no-clients">Nenhuma série cadastrada. Informe os dados abaixo para o primeiro cadastro:</p>
            <div class="new-pdv-fields">
              <mat-form-field appearance="outline" class="pdv-field">
                <mat-label>Série</mat-label>
                <input matInput type="number" [(ngModel)]="newPdvSerie" placeholder="Série">
              </mat-form-field>
              <mat-form-field appearance="outline" class="pdv-field">
                <mat-label>Numeração</mat-label>
                <input matInput type="number" [(ngModel)]="newPdvNumeration" placeholder="Numeração">
              </mat-form-field>
              <button mat-raised-button color="primary" (click)="onSaveNewPdv()" [disabled]="isSavingPdv" type="button">
                <mat-icon *ngIf="!isSavingPdv">save</mat-icon>
                <mat-spinner diameter="20" *ngIf="isSavingPdv" style="display: inline-block; margin-right: 8px;"></mat-spinner>
                {{ isSavingPdv ? 'Salvando...' : 'Cadastrar' }}
              </button>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container>
        <div class="section">
          <h3>Certificado Digital</h3>
          <div class="subsection">
            <form [formGroup]="certificateForm" class="certificate-form" *ngIf="certificateForm.get('serialNumber')?.value">
              <div>
                <h4>Certificado Atual</h4>
                <div class="certificate-info d-flex" >
                  <div class="info-item certificate-info-item">
                    <span class="label">Válido de</span>
                    <span class="value">{{ certificateForm.get('dateValidFrom')?.value }}</span>
                  </div>
                  <div class="info-item certificate-info-item">
                    <span class="label">Válido até</span>
                    <span class="value">{{ certificateForm.get('dateValidUntil')?.value }}</span>
                  </div>
                </div>
              </div>
              </form>
          </div>

          <div class="subsection">
            <h4 class="m-0 p-0">Fazer Upload do Certificado Digital</h4>
            <form [formGroup]="certificateForm">
              <div class="file-upload">
                <input type="file" #fileInput accept=".pfx,.p12" (change)="onFileSelected($event)"
                  style="display: none;" />
                <button mat-raised-button type="button" (click)="fileInput.click()" class="file-upload-button">
                  <mat-icon>attach_file</mat-icon>
                  <span class="file-button-text">{{ selectedFile ? selectedFile.name : 'Selecionar Certificado'
                    }}</span>
                </button>
              </div>

              <div class="btn-password">
                <mat-form-field appearance="outline">
                  <mat-label>Senha do Certificado</mat-label>
                  <input matInput formControlName="password" type="password"
                    placeholder="Digite a senha do certificado">
                </mat-form-field>

                <button mat-raised-button color="primary" (click)="onSaveCertificate()" [disabled]="isSaving"
                  type="button">
                  <mat-icon *ngIf="!isSaving">save</mat-icon>
                  <mat-spinner diameter="20" *ngIf="isSaving"
                    style="display: inline-block; margin-right: 8px;"></mat-spinner>
                  {{ isSaving ? 'Salvando...' : 'Salvar Certificado' }}
                </button>
              </div>
            </form>
          </div>
        </div>


        <div class="section">
          <h3>Complete as informações necessárias</h3>
          <!-- Informações NFCe -->
          <div class="subsection">
            <h4>Informações NFCe</h4>
            <form [formGroup]="nfceForm" class="nfce-form">
              <mat-form-field class="fields-nfce-form" appearance="outline">
                <mat-label>CSC ID</mat-label>
                <input matInput formControlName="cscId" type="number" placeholder="Digite o CSC ID">
              </mat-form-field>

              <mat-form-field class="fields-nfce-form" appearance="outline">
                <mat-label>CSC (Código de Segurança do Contribuinte)</mat-label>
                <input matInput formControlName="csc" placeholder="Digite o CSC">
              </mat-form-field>

              <button mat-raised-button color="accent" class="btn-nfce-form" (click)="onSaveNfceInformation()"
                [disabled]="isSavingNfce" type="button">
                <mat-icon *ngIf="!isSavingNfce">save</mat-icon>
                <mat-spinner diameter="20" *ngIf="isSavingNfce"
                  style="display: inline-block; margin-right: 8px;"></mat-spinner>
                {{ isSavingNfce ? 'Salvando...' : 'Salvar Informações NFCe' }}
              </button>
            </form>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Erro -->
    <div *ngIf="!isLoading && !isValid" class="error-container">
      <mat-icon class="error-icon">error</mat-icon>
      <h2>Link Inválido</h2>
      <p>{{ errorMessage }}</p>
      <button mat-raised-button color="primary" (click)="validateGuid()">
        Tentar Novamente
      </button>
    </div>
  </div>
</div>